import React, { FunctionComponent } from 'react'
import Svg, {
  Circle,
  Defs,
  Ellipse,
  FeBlend,
  FeFlood,
  FeGaussianBlur,
  Filter,
  G,
  LinearGradient,
  Stop,
} from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils'

type AuroraOrbIllustrationProps = {
  size?: number
}

export const AuroraOrbIllustration: FunctionComponent<AuroraOrbIllustrationProps> = ({ size = 284 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons
  const viewBoxSize = 394.516

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`} fill='none'>
      <Defs>
        <Filter id='filter0_f' x='0' y='0' width={viewBoxSize} height={viewBoxSize} filterUnits='userSpaceOnUse'>
          <FeFlood floodOpacity='0' result='BackgroundImageFix' />
          <FeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <FeGaussianBlur stdDeviation='46.6446' result='effect1_foregroundBlur' />
        </Filter>
        <Filter id='filter1_f' x='60.7814' y='58.618' width='277.276' height='277.276' filterUnits='userSpaceOnUse'>
          <FeFlood floodOpacity='0' result='BackgroundImageFix' />
          <FeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <FeGaussianBlur stdDeviation='28.3797' result='effect1_foregroundBlur' />
        </Filter>
        <LinearGradient
          id='paint0_linear'
          x1='93.3066'
          y1='93.3066'
          x2='267.338'
          y2='301.209'
          gradientUnits='userSpaceOnUse'
        >
          <Stop offset='0.221403' stopColor={spotIllustration.orbGradientStart.fill} />
          <Stop offset='0.906996' stopColor={spotIllustration.orbGradientEnd.fill} />
        </LinearGradient>
        <LinearGradient
          id='paint1_linear'
          x1='117.541'
          y1='115.377'
          x2='254.619'
          y2='279.135'
          gradientUnits='userSpaceOnUse'
        >
          <Stop offset='0.221403' stopColor={spotIllustration.orbGradientStart.fill} />
          <Stop offset='0.906996' stopColor={spotIllustration.orbGradientEnd.fill} />
        </LinearGradient>
      </Defs>
      <G filter='url(#filter0_f)'>
        <Ellipse cx='197.258' cy='197.258' rx='103.951' ry='103.951' fill='url(#paint0_linear)' />
      </G>
      <G filter='url(#filter1_f)'>
        <Circle cx='199.419' cy='197.256' r='81.8785' fill='url(#paint1_linear)' />
      </G>
    </Svg>
  )
}
